export class HeroCarousel {
	constructor(element) {
		this.element = element;
		this.slides = Array.from(
			element.querySelectorAll("[data-hero-slide]")
		);
		this.dots = Array.from(
			element.querySelectorAll("[data-hero-dot]")
		);

		this.rotationSpeed =
			Number(element.dataset.rotationSpeed) || 3700;

		this.currentIndex = 0;
		this.timer = null;

		this.reducedMotion = window.matchMedia(
			"(prefers-reduced-motion: reduce)"
		).matches;
	}

	init() {
		if (!this.slides.length) {
			return;
		}

		this.dots.forEach((dot, index) => {
			dot.addEventListener("click", () => {
				this.showSlide(index);
				this.restart();
			});
		});

		this.element.addEventListener("mouseenter", () => {
			this.stop();
		});

		this.element.addEventListener("mouseleave", () => {
			this.start();
		});

		this.element.addEventListener("focusin", () => {
			this.stop();
		});

		this.element.addEventListener("focusout", (event) => {
			if (!this.element.contains(event.relatedTarget)) {
				this.start();
			}
		});

		document.addEventListener("visibilitychange", () => {
			if (document.hidden) {
				this.stop();
			} else {
				this.start();
			}
		});

		this.showSlide(0);
		this.start();
	}

	showSlide(index) {
		if (index < 0 || index >= this.slides.length) {
			return;
		}

		this.slides.forEach((slide, slideIndex) => {
			const isActive = slideIndex === index;

			slide.classList.toggle("is-active", isActive);
			slide.setAttribute("aria-hidden", String(!isActive));
		});

		this.dots.forEach((dot, dotIndex) => {
			const isActive = dotIndex === index;

			dot.classList.toggle("is-active", isActive);
			dot.setAttribute("aria-selected", String(isActive));
		});

		this.currentIndex = index;

		if (this.currentIndex === this.slides.length - 1) {
			this.stop();
		}
	}

	next() {
		const nextIndex = this.currentIndex + 1;

		if (nextIndex >= this.slides.length) {
			this.stop();
			return;
		}

		this.showSlide(nextIndex);
	}

	start() {
		if (
			this.reducedMotion ||
			this.timer ||
			this.currentIndex >= this.slides.length - 1
		) {
			return;
		}

		this.timer = window.setInterval(() => {
			this.next();
		}, this.rotationSpeed);
	}

	stop() {
		if (!this.timer) {
			return;
		}

		window.clearInterval(this.timer);
		this.timer = null;
	}

	restart() {
		this.stop();
		this.start();
	}
}

export function initialiseHeroCarousels() {
	document.querySelectorAll("[data-hero]").forEach((element) => {
		const carousel = new HeroCarousel(element);
		carousel.init();
	});
}
